// extracted by mini-css-extract-plugin
export default {"banner-container-zindex":"1000","bannerContainerZindex":"1000","container":"_2RGlV"};